import '../../css/pages/product-page.scss';
import customSelect from '../modules/custom-select/custom-select';
import { scrollPageToTop } from '../modules/scroll-to-top/scroll-to-top';
import { displayResponse, recaptchaFunction } from '../modules/recaptcha-functions/recaptcha-functions';
import { gaTracking } from '../modules/event/event';
import componentCarousel from '../modules/component-carousel/component-carousel';

let FORM_SELECTOR = '.page-container form';
if (document.querySelector('body').classList.contains('productPage')) FORM_SELECTOR = ".modal form";

const init = async () => {
    console.log('enquiry form init');
    setUpForm();
    componentCarousel();
};

export const setUpForm = () => {
    const form = document.querySelector(FORM_SELECTOR) as HTMLFormElement;
    const url = form?.getAttribute('action');
    customSelect();

    form?.addEventListener('submit', async (e) => {
        e.preventDefault();

        const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
        submitButton.classList.add('disabled');       

        const formInfo = new FormData(form as HTMLFormElement);
        let result = await recaptchaFunction();        

        if (result.success) {
            fetch(url, {
                method: 'POST',
                body: formInfo
            })
                .then(r => {
                    return r.json();
                })
                .then(data => {
                    displayResponse(data);
                    scrollPageToTop();

                    if (data.success) {
                        form.querySelectorAll('input').forEach(input => { input.value = ""; });
                        form.querySelectorAll('textarea').forEach(input => { input.value = ""; });
                        form.querySelectorAll('select').forEach(select => { select.selectedIndex = 0; });
                        if (url == '/enquiry/credit') {
                            form.querySelectorAll('.form-group, small').forEach(group => {
                                group.classList.add('hidden');
                            });
                            gaTracking('form_submit', false, {
                                method: "Site form",
                                form_name: "Trade account application form"
                            });
                        } else {
                            const pageTitle = document.querySelector<HTMLTitleElement>('h1');
                            let formTitle = "Contact us";
                            if (pageTitle) formTitle = `${pageTitle.innerText.toLowerCase()} form`;
                            gaTracking('form_submit', false, {
                                method: "Site form",
                                form_name: formTitle
                            });
                        }
                    }
                });
        } else displayResponse(result);
            
        setTimeout(() => { submitButton.classList.remove('disabled'); }, 1000);
    });
};

const exit = () => {
    console.log("Enquiry Form: Exit");
};

window.enquiryform = {
    init,
    exit
};